import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { User } from '@/shared/api/types';

export interface MfaChallengeState {
  challenge_token: string;
  channel: 'email' | 'sms';
  target: string;
}

export interface CustomerState {
  isAuthenticated: boolean;
  isLoading?: boolean;
  user?: Partial<User> | null;
  token?: string | null;
  mfaChallenge?: MfaChallengeState | null;
  mfaError?: string | null;
}

const initialState: CustomerState = {
  isAuthenticated: false,
  isLoading: false,
  mfaChallenge: null,
  mfaError: null,
};

export const authSlide = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetState: () => initialState,
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.mfaChallenge = null;
      state.mfaError = null;
    },
    setLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
      state.isLoading = action.payload.isLoading;
    },
    setUser: (
      state,
      action: PayloadAction<{ user?: Partial<User> | null }>,
    ) => {
      state.isAuthenticated = !!action.payload.user;
      state.user = action.payload.user;
    },
    setToken: (state, action: PayloadAction<{ token?: string | null }>) => {
      state.token = action.payload.token;
    },
    setMfaChallenge: (
      state,
      action: PayloadAction<MfaChallengeState | null>,
    ) => {
      state.mfaChallenge = action.payload;
      state.mfaError = null;
    },
    setMfaError: (state, action: PayloadAction<string | null>) => {
      state.mfaError = action.payload;
    },
  },
});

export const {
  resetState,
  logout,
  setUser,
  setLoading,
  setToken,
  setMfaChallenge,
  setMfaError,
} = authSlide.actions;
